(function ($){
    function ResponsivePagination(element, options) {
        var self = this,
            $element = $(element),
            makeResponsiveTimeout,
            makeResponsiveDelay = 125;

        this.element = element;
        this.options = options || {};

        this.getCurrentPage = function () {
            if (this.options.getCurrentPageCallback) {
                return this.options.getCurrentPageCallback(self)
            } else {
                return $element.find('.active').text().trim();
            }
        };

        this.getPageItem = function (page) {
            if (this.options.getPageItemCallback) {
                return this.options.getPageItemCallback(page, self)
            } else {
                // TODO
            }
        };

        this.makeResponsive = function () {
            if (! $element.width()) {
                return;
            }

            $element.find('[data-responsive-pagination="hidden"]').each(function () {
                $(this).removeAttr('data-responsive-pagination').show();
            });

            $element.find('[data-responsive-pagination="etc"]').remove();

            var margin = 0,
                $container = $element.closest('.container'),
                $liItems = $element.find('li'),
                itemWidth = $liItems.first().width(),
                isTooLarge = $liItems.length * itemWidth + margin * 2 > $container.width();

            if (! isTooLarge) {
                return;
            }

            var allowedItemCount = Math.floor(($container.width() - margin * 2) / itemWidth) - 1,
                page = self.getCurrentPage(),
                pages = $liItems.length - 2,
                toShowPages = [1, page, pages].filter(function (value, index, me) {
                    return me.indexOf(value) === index;
                }),
                rightShowCount = 0,
                leftShowCount = 0,
                direction = 1,
                pageToShow,
                i;

            while (toShowPages.length < allowedItemCount) {
                if (direction > 0) {
                    pageToShow = page + rightShowCount + 1;

                    if (-1 === toShowPages.indexOf(pageToShow) && pageToShow <= pages) {
                        toShowPages.push(pageToShow);
                        rightShowCount++;
                    } else {
                        pageToShow = page - leftShowCount - 1;
                        toShowPages.push(pageToShow);
                        leftShowCount++;
                    }
                } else {
                    pageToShow = page - leftShowCount - 1;

                    if (-1 === toShowPages.indexOf(pageToShow) && pageToShow >= 1) {
                        toShowPages.push(pageToShow);
                        leftShowCount++;
                    } else {
                        pageToShow = page + rightShowCount + 1;
                        toShowPages.push(pageToShow);
                        rightShowCount++;
                    }
                }

                direction = direction * -1;
            }

            var sorter = function (a, b) {
                if(typeof a === 'number' && typeof b === 'number'){
                    return a - b;
                }else if(typeof a === 'number' && typeof b !== 'number'){
                    return -1;
                }else if(typeof a !== 'number' && typeof b === 'number'){
                    return 1;
                }else{
                    return a > b ? 1 : -1;
                }
            }

            toShowPages.sort(sorter);

            var toShowPage;
            var etcPages = [];
            var walker = 0;

            for (i = 0; i < toShowPages.length; i++) {
                toShowPage = toShowPages[i];
                if (walker + 1 !== toShowPage) {
                    etcPages.push(walker === 1 ? toShowPage : walker);
                    walker = toShowPage;
                } else {
                    walker++;
                }
            }

            var $pageItem;

            for (i = 1; i <= pages; i++) {
                $pageItem = self.getPageItem(i);

                if (-1 !== etcPages.indexOf(i)) {
                    $pageItem.after([
                        '<li class="page-item" style="margin-right: 10px;" data-responsive-pagination="etc">',
                        '    <span>...</span>',
                        '</li>'
                    ].join(''));
                }

                $pageItem.hide().attr('data-responsive-pagination', 'hidden');
            }

            for (i = 0; i < toShowPages.length; i++) {
                toShowPage = toShowPages[i];

                if (-1 === etcPages.indexOf(toShowPage)) {
                    $pageItem = self.getPageItem(toShowPage);

                    $pageItem.removeAttr('data-responsive-pagination').show();
                }
            }
        };

        $(window).resize(function () {
            clearTimeout(makeResponsiveTimeout);

            makeResponsiveTimeout = setTimeout(function () {
                self.makeResponsive();
            }, makeResponsiveDelay);
        });

        this.makeResponsive();
    }

    jQuery.fn.responsivePagination = function (optionsOrMethod) {
        var method = typeof optionsOrMethod === 'string' || optionsOrMethod instanceof String ? optionsOrMethod : null;

        return this.each(function() {
            var $this = $(this);

            if (! method && ! $this.data('reponsivePagination.instance')) {
                $this.data('reponsivePagination.instance', new ResponsivePagination(this, optionsOrMethod));
            }

            if (method) {
                $this.data('reponsivePagination.instance').makeResponsive();
            }

            return this;
        });
    };
}(jQuery));
